import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
// CComponents
import {Button} from '@frontrow/console/src/components/button'
import {type BaseTeacherAttrs as TeacherT} from '@frontrow/console/src/entities/models/teacher'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTrashAlt} from '@fortawesome/free-regular-svg-icons'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  teacher: TeacherT
  deleteTeacher: (teacherId: number) => void
}

export default function DeleteTeacherButtonModal(props: Props): React.ReactElement {
  const {isOpen, open, close} = useModalForm()
  const {teacher} = props

  const deleteTeacher = () => {
    props.deleteTeacher(teacher.id)
    close()
  }

  return (
    <React.Fragment>
      <Button title="Delete Teacher" dataTest="delete-teacher-button" style="link" onClick={open}>
        <FontAwesomeIcon icon={faTrashAlt} size="lg" />
      </Button>

      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>Delete teacher</DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          This will mark{' '}
          <em>
            {teacher.firstName} {teacher.lastName}
          </em>{' '}
          as pending deletion. Teachers marked as pending deletion will be purged periodically from
          the database every night.
        </div>
        <div className={dialogStyles.footer}>
          <Button style="secondary" onClick={close}>
            Cancel
          </Button>
          <Button style="danger" onClick={deleteTeacher}>
            Delete
          </Button>
        </div>
      </Dialog>
    </React.Fragment>
  )
}
